// Generated by CoffeeScript 2.7.0
var Condition;

import UserBoundary from '../user_boundary.js';

import BaseModel from '../base_model.js';

export default Condition = (function() {
  class Condition extends BaseModel {
    static createFieldCondition(field, edge) {
      var new_condition;
      new_condition = new this({
        conditionable_type: 'Field',
        conditionable_id: field.id,
        judgements: {}
      }, edge);
      edge.conditions.push(new_condition);
      return new_condition;
    }

    constructor(attrs, edge) {
      super(attrs);
      this.edge = edge;
      if (this.isUserBoundaryCondition()) {
        this.user_boundary = new UserBoundary(_.extend({}, attrs.user_boundary, {
          overlord: edge
        }));
        this.judgements = {
          presence: {
            present: true
          }
        };
      }
    }

    isUserBoundaryCondition() {
      return this.conditionable_type === 'UserBoundary';
    }

    getFieldConditionable() {
      if (this._field) {
        return this._field;
      }
      return this._field = this.edge.graph.flow.getFieldById(this.conditionable_id);
    }

    getOptionByJudgement(option_id) {
      var field;
      field = this.getFieldConditionable();
      if (option_id === 0) {
        return {
          id: 0,
          value: field.other_option
        };
      } else {
        return _.find(field.options || [], function(option) {
          return option.id === option_id;
        });
      }
    }

    delete() {
      if (this.isNew()) {
        return this.edge.conditions = _.rejectFirst(this.edge.conditions, (condition) => {
          return condition === this;
        });
      } else {
        return this._destroy = true;
      }
    }

    isEmpty() {
      if (this.isUserBoundaryCondition()) {
        return this.user_boundary.isEmpty();
      } else {
        return _.isEmpty(this.judgements);
      }
    }

    toJSON() {
      var condition;
      if (this.isEmpty() && this.isNew()) {
        return null;
      }
      if (this.isEmpty()) {
        this.delete();
      }
      condition = super.toJSON();
      if (this.isUserBoundaryCondition()) {
        condition.user_boundary_attributes = this.user_boundary.toJSON();
      }
      return _.omit(condition, 'user_boundary');
    }

  };

  Condition.setAttributes([
    'user_boundary',
    'conditionable_type',
    'conditionable_id',
    {
      judgements: {}
    }
  ]);

  return Condition;

}).call(this);
